<div class="ftmSts">
    <mat-tab-group dynamicHeight>
        <mat-tab label="I'm a Customer">
            <form #f="ngForm" [formGroup]="customerForm" (ngSubmit)="imcustomer()">
                    <div class="formGroup">
                        <mat-form-field appearance="fill">
                            <input formControlName="username" matInput placeholder="Your Name*">
                        </mat-form-field>
                        <div class="errorTxt">
                            <div
                                *ngIf="customerForm?.get('username')?.touched || customerForm?.get('username')?.dirty">
                                <div *ngIf="customerForm?.get('username')?.hasError('required')">
                                    Name is required
                                </div>
                                <div *ngIf="customerForm?.get('username')?.hasError('maxlength')">
                                    Name not longer than 30 characters.
                                </div>
                                <div *ngIf="customerForm?.get('username')?.hasError('pattern')">
                                    Please enter only characters.
                                </div>
                            </div>
                        </div>
    
                    </div>
                    <div class="formGroup">
                        <mat-form-field appearance="fill">
                            <input formControlName="companyEmail" matInput placeholder="Company Email*" >
                        </mat-form-field>
                        <div class="errorTxt">
                            <div
                                *ngIf="customerForm?.get('companyEmail')?.touched || customerForm?.get('companyEmail')?.dirty">
                                <div *ngIf="customerForm?.get('companyEmail')?.hasError('required')">
                                    Email is required
                                </div>
                                <div
                                    *ngIf="customerForm?.get('companyEmail')?.value != '' && (customerForm?.get('companyEmail')?.hasError('email') || customerForm?.get('companyEmail')?.hasError('numericAfterDotCom'))">
                                    Must be a valid email address
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="formGroup phone_number">
                        <ngx-intl-tel-input
                            [cssClass]="'custom'"
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[
                            SearchCountryField.Iso2,
                            SearchCountryField.Name
                            ]"
                            customPlaceholder="Phone number*"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.India"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National"
                            name="phone"
                            formControlName="phone"
                        >
                        </ngx-intl-tel-input> 
                        
                        <div class="errorTxt">
                            <div
                                *ngIf="customerForm?.get('phone')?.touched || customerForm?.get('username')?.dirty">
                                <div *ngIf="customerForm?.get('phone')?.hasError('required')">
                                    Phone number is required
                                </div>
                                <div *ngIf="customerForm?.get('phone')?.hasError('validatePhoneNumber')">
                                    Please enter valid Phone number
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formGroup">
                        <mat-form-field appearance="fill">
                            <textarea matInput formControlName="comments" placeholder="Drop a note, or tell us about your project..."></textarea>
                        </mat-form-field>
                    </div>
                    <div class="formButton">
                            <button type="reset" mat-button class="btn-custom btn-outline blackCta" (click)="resetForm()">Reset</button>
                            <button type="submit" mat-button class="btn-custom btn-solid" [ngClass]="{'disable': isValid()}"> <mat-icon>send</mat-icon> Send</button>
                    </div>
            </form>
        </mat-tab>
        <mat-tab label="I'm a Supplier">
            <form [formGroup]="supplierForm" (ngSubmit)="imsupplier()">
                <div class="formGroup">
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="Your Name*" formControlName="username" >
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="supplierForm?.get('username')?.touched || supplierForm?.get('username')?.dirty">
                            <div *ngIf="supplierForm?.get('username')?.hasError('required')">
                                Name is required
                            </div>
                            <div *ngIf="supplierForm?.get('username')?.hasError('maxlength')">
                                Name not longer than 30 characters
                            </div>
                            <div *ngIf="customerForm?.get('username')?.hasError('pattern')">
                                Please enter only characters.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="formGroup">
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="Company Email*" formControlName="companyEmail">
                    </mat-form-field>
                    <div class="errorTxt">
                        <div
                            *ngIf="supplierForm?.get('companyEmail')?.touched || supplierForm?.get('companyEmail')?.dirty">
                            <div *ngIf="supplierForm?.get('companyEmail')?.hasError('required')">
                                Email is required
                            </div>
                            <div
                                *ngIf="supplierForm?.get('companyEmail')?.value != '' && (supplierForm?.get('companyEmail')?.hasError('email') || supplierForm?.get('companyEmail')?.hasError('numericAfterDotCom'))">
                                Must be a valid email address
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="formGroup phone_number">
                    <ngx-intl-tel-input
                            [cssClass]="'custom'"
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[
                            SearchCountryField.Iso2,
                            SearchCountryField.Name
                            ]"
                            customPlaceholder="Phone number*"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.India"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National"
                            name="phone"
                            formControlName="phone"
                        >
                    </ngx-intl-tel-input> 
                    <div class="errorTxt">
                        <div
                            *ngIf="supplierForm.get('phone')?.touched || supplierForm.get('username')?.dirty">
                            <div *ngIf="supplierForm.get('phone')?.hasError('required')">
                                Phone number is required
                            </div>
                            <div *ngIf="supplierForm.get('phone')?.hasError('validatePhoneNumber')">
                                Please enter valid Phone number
                            </div>
                        </div>
                    </div>
                </div>
                <div class="formGroup">
                    <mat-form-field appearance="fill">
                        <textarea matInput formControlName="comments"  placeholder="Drop a note, or tell us about your project..."></textarea>
                    </mat-form-field>
                </div>
                <div class="formButton">
                        <button mat-button class="btn-custom btn-outline blackCta" (click)="resetSupplier()" type="button">Reset</button>
                        <button mat-button class="btn-custom btn-solid" [ngClass]="{'disable': isValidSupplier()}"> <mat-icon>send</mat-icon> Send</button>
                </div>
            </form>
        </mat-tab>
    </mat-tab-group>
</div>
